































































































import Vue from 'vue'
import drawer from './drawer.vue'
import { cloneDeep } from 'lodash'
import { columnsMethod, dataTypes, formTypes } from './data'
import { IotAppMethodServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'

const iamsp = new IotAppMethodServiceProxy()
export default Vue.extend({
  props: ['app', 'gatewayCode'],
  components: { drawer },
  data() {
    return {
      dataTypes,
      dataList: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      visible: false,
      showImplement: false,
      loading: false,
      selectRowKey: '',
      selectRow: {},
      submitLoading: false,
      form: {},
      formItems: [], // 表单项，动态生成
      message: ''
    }
  },
  computed: {
    columnsMethod() {
      return columnsMethod.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    drawerTitle() {
      if (this.app) {
        return this.app.name + this.$t('page_getwat_list_method')
      } else {
        return ''
      }
    }
  },
  methods: {
    showDrawer() {
      this.visible = true
      this.getList()
    },
    onClose() {
      this.visible = false
    },
    async getParamList(record) {
      let params: any = {
        appCode: this.app.code,
        gatewayCode: this.gatewayCode,
        code: record.code
      }
      let { items } = await iamsp.getMethodParamList(params)
      console.log(items)
      this.handleFormItems(items)
      this.showChange(record)
    },
    showChange(record?) {
      this.message = ''
      this.showImplement = !this.showImplement
      if (this.showImplement) {
        this.selectRow = record
        this.selectRowKey = record.id
      }
    },
    handleFormItems(data) {
      let dTypes = Object.keys(dataTypes)
      let fTypes = Object.keys(formTypes)
      let tempForm = [], form = {}
      let newData = cloneDeep(data)
      newData.map(item => {
        let temp
        dTypes.map(t => {
          if (item.type.toLowerCase() === dataTypes[t].toLowerCase()) {
            temp = {
              typeNum: t, label: item.name, key: item.name, placeholder: item.description
            }
          }
        })
        fTypes.map(ft => {
          if (formTypes[ft].includes(Number(temp.typeNum))) {
            temp.multi = !!(~ft.indexOf('multi'))
            temp.type = ft
          }
        })
        form[item.name] = ''
        tempForm.push(temp)
      })
      this.formItems = tempForm
      this.form = form
      console.log('form:', this.formItems)
    },
    async getList() {
      this.dataList = []
      if (!this.app || !this.gatewayCode) {
        return
      }
      this.loading = true
      try {
        let { items } = await iamsp.getIotAppMethodList(this.app.code, this.gatewayCode)
        this.dataList = cloneDeep(items)
        // this.dataList.map((item, index) => item.rowKey = index)
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    async submit() {
      this.message = ''
      this.submitLoading = true
      let params: any = {
        appCode: this.app.code,
        execParamMap: this.form,
        gatewayCode: this.gatewayCode,
        isAsync: false,
        methodId: this.selectRow.code
      }
      try {
        let res = await iamsp.execMethod(params)
        if (res && res.message && res.message !== 'null') {
          let str = JSON.parse(res.message)
          if (str.hasOwnProperty('responseCode')) {
            this.message = str.responseCode === 0 ? { value: str.dataValue, extraClass: 'success' } :
              { value: str.message, extraClass: 'error' }
          } else {
            this.message = { value: res.message, extraClass: 'error' }
          }
        }
      } catch (e) {
        console.log(e)
      }
      this.submitLoading = false

    },
    refresh() {
      this.getList()
    }
  }
})
